/**
 * Enumeration of access levels a reseller can have.
 *
 * @readonly
 * @enum {string}
 */
export const AccountDealerAccessLevel = Object.freeze({
    STANDARD: 'STANDARD',
    EXPERT: 'EXPERT',
    ADMIN: 'ADMIN'
})
